<template>
  <div style="width: 90%">
    <div class="container_body">
      <header class="header_nav">
        <!-- <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="分类名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.className" placeholder="请输入分类名称">
								</el-input>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="editialogVisible('',1)">新增分类
							</el-button>
						</template>
					</el-form-item>
				</el-form> -->
      </header>
    </div>

    <el-table
      :data="goodsClassList"
      style="width: 100%"
      :header-cell-style="headClass"
      border
      lazy
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <el-table-column
        prop="userId"
        label="用户ID"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="code"
        label="酒柜编号"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="storeName"
        label="所属店铺"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="storeLogo"
        label="酒柜logo"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img
            v-if="scope.row.storeLogo"
            :src="scope.row.storeLogo"
            @click="
              dialogImageUrl = scope.row.storeLogo;
              dialogVisibleImg = true;
            "
            width="50px"
          />
          <div v-else>暂无图标</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="storeBackground"
        label="店铺背景"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img
            v-if="scope.row.storeBackground"
            :src="scope.row.storeBackground"
            @click="
              dialogImageUrl = scope.row.storeBackground;
              dialogVisibleImg = true;
            "
            width="50px"
          />
          <div v-else>暂无图标</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="level" label="分类等级" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
      <el-table-column
        prop="status"
        label="是否启用"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.status == 1">是</p>
          <p v-else>否</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="checkState"
        label="状态"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template v-slot="scope">
          <span v-if="scope.row.checkState == 0">待审核</span>
          <span v-if="scope.row.checkState == 1">通过</span>
          <span v-if="scope.row.checkState == 2">驳回</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="saleNums"
        label="销量"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="详细地址"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template v-slot="scope">
          <span
            >{{ scope.row.province ? scope.row.province : ""
            }}{{ scope.row.city ? scope.row.city : ""
            }}{{ scope.row.area ? scope.row.area : ""
            }}{{ scope.row.address ? scope.row.address : "" }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="text"
            @click="editialogVisible(scope.row.id)"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="text"
            @click="deltialogVisible(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin: 20px"
      background
      :current-page="goodsClassList.pageNum"
      @current-change="pageChange"
      layout="total, sizes, prev, pager, next, jumper"
      :total="goodsClassList.total"
      @size-change="handleSizeChange"
    >
    </el-pagination>

    <!-- 查看 -->
    <el-dialog
      :closeOnClickModal="false"
      title="提示"
      :visible.sync="showContentDialog"
      width="50%"
    >
      <span v-html="contentValue"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showContentDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      style="float: rigin"
      :title="title"
      :visible.sync="editDialogVisible"
      width="50%"
      :closeOnClickModal="false"
    >
      <div class="app-container">
        <el-form
          ref="form"
          :model="form"
          :rules="mainFormRules"
          :label-width="formLabelWidth"
          size="medium"
        >
          <!-- <el-form-item v-if="form.level>=2" label="一级分类:">
						<el-select clearable v-model="classGoods1Id" placeholder="请选择一级分类" style="width:200px;margin-right:10px;"
							@change="classGoods1">
							<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item v-if="form.level==3" label="二级分类:">
						<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类" style="width:200px;margin-right:10px;"
							@change="classGoods2">
							<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->

          <!-- <el-form-item label="分类等级:">
						<div>{{form.level}}</div>
					</el-form-item> -->

          <el-form-item label="酒柜编号:">
            <el-input
              v-model="form.code"
              :disabled="true"
              style="width: 260px"
              placeholder="请输入酒柜编号"
            />
          </el-form-item>

          <el-form-item label="酒柜logo:">
            <br />
            <el-upload
              :action="imgUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :show-file-list="true"
              :on-success="onSuccess"
              :on-exceed="handleExceed"
              :before-remove="beforeRemove"
              :limit="1"
              style="margin-lift: 0"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="店铺背景:">
            <br />
            <el-upload
              :action="imgUrls"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove1"
              :file-list="fileList1"
              :show-file-list="true"
              :on-success="onSuccess1"
              :on-exceed="handleExceed1"
              :before-remove="beforeRemove"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item label="酒柜logo:">
            <el-upload
              class="upload-demo"
              :action="imgUrl"
              :on-preview="handlePreview"
              :show-file-list="false"
              :on-success="onSuccess"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="酒柜logo">
            <img
              v-if="form.storeLogo"
              :src="form.storeLogo"
              @click="
                dialogImageUrl = form.imastoreLogoge;
                dialogVisibleImg = true;
              "
              width="100px"
            />
            <div v-else>请上传图片</div>
          </el-form-item> -->
          <!-- <el-form-item label="店铺背景:">
            <el-upload
              class="upload-demo"
              :action="imgUrls"
              :on-preview="handlePreview"
              :show-file-list="false"
              :on-success="onSuccess"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="店铺背景">
            <img
              v-if="form.storeBackground"
              :src="form.storeBackground"
              @click="
                dialogImageUrl = form.bgimastoreLogoge;
                dialogVisibleImg = true;
              "
              width="100px"
            />
            <div v-else>请上传图片</div>
          </el-form-item> -->
          <el-form-item label="是否启用:">
            <el-switch
              v-model="form.status"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>

          <!-- <el-form-item label="是否显示:">
						<el-switch v-model="form.isShow" :active-value="1" :inactive-value="0">
						</el-switch>
					</el-form-item> -->

          <el-form-item label="是否启用" cleartable>
            <el-select v-model="form.checkState" placeholder="请选择">
              <el-option key="0" label="待审核" :value="0">待审核</el-option>
              <el-option key="1" label="通过" :value="1">通过</el-option>
              <el-option key="2" label="驳回" :value="2">驳回</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系地址">
            <el-input
              type="text"
              v-model="form.address"
              placeholder="请输入门店地址"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" @click="toEdit()"
              >提交</el-button
            >
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisibleImg"
      :closeOnClickModal="false"
      @close="cancel"
    >
      <div style="text-align: center">
        <img
          width="100%"
          class="el-upload-list__item-thumbnail"
          :src="dialogImageUrl"
          alt=""
        />
      </div>
      <div style="text-align: center">
        <el-button type="primary" @click="dialogVisibleImg = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile, uploadFiles } from "@/api/axios.js";
var urls = uploadFile();
var bgurls = uploadFiles();

import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    //使用编辑器
    quillEditor,
  },
  data() {
    return {
      title: "",
      classGoods1Id: 0,
      classGoods2Id: 0,
      classGoods1List: [],
      classGoods2List: [],
      imgUrl: urls,
      imgUrls: bgurls,
      dialogVisibleImg: false,
      dialogImageUrl: "",
      fileList: [],
      fileList1: [],
      loading: false,
      goodsClassList: [], //商品分类列表
      dialogVisible: false,
      editDialogVisible: false,
      form: {
        id: 0,
        className: "",
        // level: "",
        isShow: "",
        // image: "",
        orderIndex: 0,
        // pid: 0
      },
      mainFormRules: {
        title: {
          required: true,
          message: "请输入账号",
          trigger: "blur",
        },
      },
      integralList: [],
      formLabelWidth: "200px",
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      searchInfo: {},
      index: null,
      contentValue: "",
      showContentDialog: false,
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    empty() {
      this.searchInfo = {};
    },
    search() {
      this.loading = true;
      let data = {
        id: this.$route.params.id,
      };
      this.$api.getWineCooler(data).then((res) => {
        //商品分类列表
        // console.log(res);
        if (res.state == "success") {
          this.goodsClassList = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // //选中一级分类
    // classGoods1(e) {
    // 	this.classGoods2Id = "";
    // 	if (e) {
    // 		if (this.form.level != 3) {
    // 			this.form.level = 2;
    // 			this.form.pid = e;
    // 			console.log(e)
    // 			console.log(this.form)
    // 		}

    // 		this.$api.goodsClassfindByPid(e).then((res) => { //商品二级分类
    // 			if (res.state == 'success') {
    // 				this.classGoods2List = res.data;
    // 			}
    // 		})
    // 	}
    // },
    // //选中二级分类
    // classGoods2(e) {
    // 	if (e) {
    // 		this.form.pid = e;
    // 		this.form.level = 3;
    // 	}
    // 	console.log(e)
    // 	console.log(this.form.pid)

    // },
    headClass() {
      return "text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px";
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
    },
    handleRemove1(file, fileList) {
      //console.log(file, fileList);
      this.fileList1 = this.fileList1.filter((item) => item.uid !== file.uid);
    },
    handlePreview(file) {
      //console.log(file);
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisibleImg = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        // `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        //   files.length + fileList.length
        // } 个文件`
        `温馨提示: 只能上传一个酒柜log哦`
      );
    },
    handleExceed1(files, fileList) {
      this.$message.warning(
        `温馨提示: 只能上传一个店铺背景哦`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除吗?`);
    },
    onSuccess(response, file, fileList) {
      // console.log(response);
      // this.storeImg = response.message;
      this.fileList.push({
        url: response.message,
      });
      // console.log(response);
      // var form = {
      //   id: this.form.id,
      //   className: this.form.className,
      //   level: this.form.level,
      //   isShow: this.form.isShow,
      //   image: response.data,
      //   orderIndex: this.form.orderIndex,
      //   pid: this.form.pid,
      // };
      // this.form = form;
    },
    onSuccess1(response, file, fileList) {
      // console.log(response);
      // this.storeImg = response.message;
      this.fileList1.push({
        url: response.message,
      });
    },
    showContent(content) {
      this.contentValue = content;
      this.showContentDialog = true;
    },
    //编辑弹框
    editialogVisible(id, level) {
      // this.fileList = []

      // //下拉框赋空值
      // this.classGoods1Id = "";
      // this.classGoods2Id = "";
      // this.classGoods2List = [];

      this.form = {
        id: null,
        className: "",
        // level: "",
        isShow: "",
        // image: "",
        orderIndex: 0,
        // pid: 0
      };

      if (id) {
        this.title = "编辑";
        // console.log(this.fileList, this.fileList1);
        this.fileList = [];
        this.fileList1 = [];
        //编辑查询
        this.ids = id;
        this.form.timer = [];
        // let data = {
        //   id: id,
        // };
        this.$api.getquery(id).then((res) => {
          //根据id查询商品分类
          if (res.state == "success") {
            // console.log(res.data);
            this.form = res.data[0];
            this.fileList.push({
              url: res.data[0].storeLogo,
            });
            this.fileList1.push({
              url: res.data[0].storeBackground,
            });
          }
        });
      } else {
        this.ids = "";
      }

      // if (level) {
      // 	this.form.level = level;
      // 	if (level == 1) {
      // 		this.title = '添加一级分类';
      // 	} else if (level == 2) {
      // 		this.title = '添加二级分类';
      // 	} else if (level == 3) {
      // 		this.title = '添加三级分类';
      // 	}
      // }

      this.editDialogVisible = true;
    },
    cancel() {
      this.editDialogVisible = false;
    },
    deltialogVisible(id) {
      this.$confirm("此操作将永久删除该酒柜, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.deleteClass(id).then((res) => {
            //根据id删除酒柜
            // console.log(res.data);
            if (res.state == "success") {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.findGoodsClassInfo();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    toEdit() {
      if (this.ids) {
        let data = {
          ...this.form,
          id: this.ids,
          storeLogo: this.fileList[0].url,
          storeBackground: this.fileList1[0].url,
        };
        // console.log(data);
        //编辑
        this.$api.findStoreClassedit(data).then((res) => {
          // console.log(res.data);
          if (res.state == "success") {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.editDialogVisible = false;
            this.findGoodsClassInfo(); //分类列表刷新
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        //添加
        this.loading = true;
        this.$api.addStoreClass(this.$encrypt(this.form)).then((res) => {
          if (res.state == "success") {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.editDialogVisible = false;
            this.findGoodsClassInfo();
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        });
      }
    },
    pageChange(data) {
      this.page.pageNum = data;
      this.findGoodsClassInfo();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.findGoodsClassInfo();
    },
    findGoodsClassInfo() {
      this.loading = true;
      let data = {
        storeId: this.$route.params.id,
      };
      this.$api.getWineCooler(data).then((res) => {
        //商品分类列表
        if (res.state == "success") {
          this.goodsClassList = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // goodsClassfindByPid(row, expanded) {
    // 	console.log(row, expanded);
    // 	//this.loading2 = true
    // 	this.$api.goodsClassfindByPid(row.id).then((res) => { //根据pid查询商品分类
    // 		console.log(res);
    // 		if (res.state == 'success') {
    // 			this.goodsClassList2 = res.data
    // 			//this.loading2 = false
    // 		} else {
    // 			this.$message.error(res.message);
    // 		}
    // 	})
    // }
  },
  created() {
    this.findGoodsClassInfo();
    // this.$api.goodsClassfindByPid(0).then((res) => { //商品一级分类
    // 	if (res.state == 'success') {
    // 		this.classGoods1List = res.data;
    // 	}
    // })
  },
  mounted: function () {},
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 100px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.lpc-quill img {
  width: 100px;
  height: 120px;
}

.lpc-quill-en img {
  width: 100px;
  height: 120px;
}
</style>
